














































































import { Vue, Component, Ref } from "vue-property-decorator";
import SlideView from "@/components/slides/SlideView.vue";
import LectureVideoView from "@/components/slides/LectureVideoView.vue";
import LectureExtraMaterialView from "@/components/slides/LectureExtraMaterialView.vue";
import LectureTextView from "@/components/slides/LectureTextView.vue";
import { Lecture as ILecture } from "@/api/models/lecture";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: {
    CBreadCrumbs,
    SlideView,
    LectureVideoView,
    LectureExtraMaterialView,
    LectureTextView
  }
})
export default class Lecture extends Vue {
  @Ref("content_block") contentBlock!: HTMLElement;
  lecture!: ILecture;

  data() {
    return {
      lecture: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "lectureList" },
        label: `${this.$tc(this.$translate.Lectures)}`
      },
      {
        label: this.$converter.limitedOutput(this.lecture.title, 60)
      }
    ];
  }

  scrollToTop() {
    this.$nextTick(() => {
      const blockTop = this.contentBlock?.offsetTop;
      window.scrollTo({
        top: blockTop,
        behavior: "smooth"
      });
    });
  }

  created() {
    api.LectureApi.get(this.$route.params.id).then(
      (res: { data: ILecture }) => {
        this.lecture = res.data;
      }
    );
  }
}
